export { default } from './createChainedFunction';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/createChainedFunction/index.js
// module id = 829
// module chunks = 25